import { useState } from 'react';
import { Loader2, Upload, Image as ImageIcon, X } from 'lucide-react';
import { fileToResizedDataUrl } from '../../../lib/image';

export function Section({ title, action, children }) {
  return (
    <section className="surface-2 border border-subtle rounded-lg p-6 md:p-8">
      <div className="flex items-center justify-between gap-4 flex-wrap mb-6">
        <h2 className="font-display text-2xl text-prim tracking-tight">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-mono uppercase tracking-[0.2em] text-muted mb-2">{label}</label>
      {children}
    </div>
  );
}

export function Modal({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 z-[200] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="surface border border-subtle rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-subtle sticky top-0 surface z-10">
          <h3 className="font-display text-xl text-prim tracking-tight">{title}</h3>
          <button onClick={onClose} className="text-muted hover:text-prim"><X size={20} /></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export function ImageUpload({ value, onChange, label = 'Upload image' }) {
  const [busy, setBusy] = useState(false);
  const [broken, setBroken] = useState(false);
  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const data = await fileToResizedDataUrl(file, { maxDim: 1200, quality: 0.85 });
      setBroken(false);
      onChange(data);
    } finally {
      setBusy(false);
    }
  };
  const showImg = value && !broken;
  return (
    <div className="flex items-center gap-4">
      <div className="w-24 h-24 rounded-md border border-subtle surface overflow-hidden flex items-center justify-center">
        {showImg ? (
          <img src={value} alt="" className="photo-fit" onError={() => setBroken(true)} />
        ) : (
          <ImageIcon size={20} className="text-muted" />
        )}
      </div>
      <div className="flex flex-col gap-2">
        <label className="btn-secondary text-xs cursor-pointer">
          {busy ? <><Loader2 size={12} className="animate-spin" /> …</> : <><Upload size={12} /> {label}</>}
          <input type="file" accept="image/*" onChange={onPick} className="hidden" />
        </label>
        {value && <button type="button" onClick={() => { setBroken(false); onChange(''); }} className="text-xs text-muted hover:text-prim">Remove</button>}
        {broken && <span className="text-[10px] text-brand-maroon-light">Saved image is invalid — please re-upload.</span>}
      </div>
    </div>
  );
}
